import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAvailableAppointmentModel } from '@/visa-application/models/AvailableAppointmentModel';
import SplashCMSModel from '@/visa-application/models/SplashCMSModel';

@Component
export default class AvailableAppointmentTable extends Vue {
  @Prop()
  public availableAppointments: IAvailableAppointmentModel[];
  @Prop()
  public splashCMSData: SplashCMSModel;

  public currentLanguage = this.$store.getters.currentLanguage;
  private unwatchCurrentLanguage: Function;

  public created(): void {
    this.unwatchCurrentLanguage = this.$store.watch(
      () => this.$store.getters.currentLanguage,
      currentLanguage => {
        this.currentLanguage = currentLanguage;
      }
    );
  }

  public beforeDestroy(): void {
    this.unwatchCurrentLanguage();
  }

  public formatToLocalDate(date: string): string {
    if (date === undefined || isNaN(Date.parse(date))) {
      return 'N/D';
    }
    const localeFormat = new Intl.DateTimeFormat(this.currentLanguage).format;
    return localeFormat(new Date(date));
  }
}
